/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
export default class Scene extends PIXI.Container {
    constructor() {
        super();

        /**
         * @member {object} signals
         * @member {signals.Signal} signals.next
         * @member {signals.Signal} signals.previous
         * @member {signals.Signal} signals.home
         * @member {signals.Signal} signals.pause
         */
        this.signals = {
            next: new signals.Signal(),
            previous: new signals.Signal(),
            home: new signals.Signal(),
            pause: new signals.Signal()
        };

        /**
         * @member {boolean} - The scene has finished loading its required manifest.
         */
        this.loaded = false;

        /**
         * @member {boolean} - The scene is always updated regardless of its place in the stack.
         */
        this.alwaysUpdate = false;

        /**
         * @member {boolean} - The scene will call appear automatically.
         */
        this.autoAppear = true;
    }

    /**
     * @returns {Scene}
     */
    preloader() {
        return new Scene();
    }

    /**
     * @returns {Array}
     */
    load() {
        return [];
    }

    unload() {
        // override
    }

    /**
     * This method is called when a scene is initialized.
     */
    init() {
        // override
    }

    /**
     * This method is called when a scene is destroyed.
     *
     * @param options
     * @param [options.children=false]
     * @param [options.texture=false]
     * @param [options.baseTexture=false]
     */
    destroy(options) {
        this.signals.next.dispose();
        this.signals.previous.dispose();
        this.signals.home.dispose();
        this.signals.pause.dispose();

        super.destroy(options);
    }

    /**
     * This method is called when the device dimensions are changed.
     */
    resize() {
        // override
    }

    /**
     * This method is called when the scene is 'top' of the stack.
     */
    update() {
        // override
    }

    /**
     * This method is called when the scene is shown for the first time.
     */
    appear() {
        this.animateIn();
    }

    /**
     * This method is called when the scene is shown - regardless of actual visibility.
     */
    show() {
    }

    /**
     * This method is called when the scene is hidden - regardless of actual visibility.
     */
    hide() {
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateOut(callback, scope) {
    }
}